<template>
  <fade-in-component class="_mb90">
    <h2 class="ttlyb _mb30">
      <span class="ttlybtxt">業界同士の比較をのぞく</span>
    </h2>
    <ul class="contents-ul">
      <li class="list -l02" v-if="num != 2">
        <router-link to="/stereotype" class="link">
          <div class="typeimg">
            <img
              src="../assets/img/cmn/tie.svg"
              alt="「できる営業像」の思い込み"
              class="img"
            />
          </div>
          <p class="typetxt">「できる営業像」<br />の思い込み</p>
          <span class="linkbtn">詳しく見る</span>
        </router-link>
      </li>
      <li class="list -l03" v-if="num != 3">
        <router-link to="/highperformer" class="link">
          <div class="typeimg">
            <img
              src="../assets/img/cmn/mountain.svg"
              alt="ハイパフォーマー特性"
              class="img"
            />
          </div>
          <p class="typetxt">ハイパフォーマー特性</p>
          <span class="linkbtn">詳しく見る</span>
        </router-link>
      </li>
      <li class="list -l04" v-if="num != 4">
        <router-link to="/relationship" class="link">
          <div class="typeimg">
            <img
              src="../assets/img/cmn/hart.svg"
              alt="対人関係にみられる特徴"
              class="img"
            />
          </div>
          <p class="typetxt">対人関係に<br />みられる特徴</p>
          <span class="linkbtn">詳しく見る</span>
        </router-link>
      </li>
      <li class="list -l01" v-if="num != 1">
        <router-link to="/decision" class="link">
          <div class="typeimg">
            <img
              src="../assets/img/cmn/flag.svg"
              alt="意思決定にみられる特徴"
              class="img"
            />
          </div>
          <p class="typetxt">意思決定に<br />みられる特徴</p>
          <span class="linkbtn">詳しく見る</span>
        </router-link>
      </li>

    </ul>

    <router-link to="/" class="backtotoppage">トップページに戻る</router-link>
  </fade-in-component>

</template>

<script>
import FadeInComponent from "../components/FadeInComponent.vue";
export default {
  props: ["contentsNum"],
  components: {
    FadeInComponent
  },  
  data() {
    return {
      num: this.contentsNum,
    };
  },
};
</script>
